import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { signUp, getCurrentUser, fetchUserAttributes, confirmResetPassword, resetPassword, signOut } from "aws-amplify/auth";
import WelcomePage from "./WelcomePage";
import SuccessPage from "./SuccessPage";
import { 
  CognitoIdentityProviderClient, 
  InitiateAuthCommand,
  RespondToAuthChallengeCommand 
} from '@aws-sdk/client-cognito-identity-provider';

import "./App.css";
import awsconfig from "./aws-exports";
import { Amplify } from "aws-amplify";
Amplify.configure(awsconfig);

const SESSION_DURATION = 60 * 60 * 1000; // 60 minutes in milliseconds

const Spinner = () => (
  <svg
    className="spinner"
    viewBox="0 0 24 24"
  >
    <circle
      className="spinner-circle"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      fill="none"
    />
    <path
      className="spinner-path"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

// Protected Route Component
function ProtectedRoute({ children, user }) {
  if (!user) {
    return <Navigate to="/signin" replace />;
  }
  return children;
}

// Sign In Page Component
function SignInPage({ onSignIn }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [isDeviceRegister, setDeviceRegister] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [randomToken, setRandomToken] = useState("");
  const [isStartingDeviceReg, setIsStartingDeviceReg] = useState(false);

  const generateRandomToken = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  const startDeviceRegisration = async (e) => {
    e.preventDefault();
    setIsStartingDeviceReg(true);
    setError('');
    setFieldErrors({});

    try {
      const token = generateRandomToken();

      const body = {
        username,
        token,
      };
      await fetch("https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/storeTempDeviceToken", {
        method: "POST",
        body: JSON.stringify(body),
      });

      setRandomToken(token);
      setShowToken(true);
      setIsStartingDeviceReg(false);
      setError("");
    } catch (error) {
      console.error('Error:', error);
      setIsStartingDeviceReg(false);
      setError("Your email is not registered!");
    }
  };

  const deleteSessionId = async (username) => {
    try {
      console.log("inside try to auth delete session id");
      const response = await fetch(`https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/userSessionId?username=${username}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log("Session ID deleted successfully");
      return response;

    } catch (error) {
      console.error("Error deleting session ID:", error);
      throw error;
    }
  }

  const handleSignInCustom = async (e) => {
    e.preventDefault();
    setIsSigningIn(true);

    if (!username || !password) {
      setFieldErrors({
        username: !username ? "Username is required" : "",
        password: !password ? "Password is required" : "",
      });
      setIsSigningIn(false);
      return;
    }

    if (!isDeviceRegister) {
      const isDeviceRegisteredResponse = await fetch(`https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/deviceTokenExists?username=${username}`, {
        method: "GET",
      });
      const apiResponseData = await isDeviceRegisteredResponse.json();
      const isDeviceRegistered = apiResponseData.deviceTokenExists;
      const userExists = apiResponseData.userExists;
      console.log("isDeviceRegistered response:", apiResponseData);

      if (userExists && !isDeviceRegistered) {
        setDeviceRegister(true);
        setShowToken(false);
        setIsSigningIn(false);
        return;
      } else if (!userExists) {
        setError("Invalid username/password!");
        setIsSigningIn(false);
        return;
      }
    }

    try {
      const client = new CognitoIdentityProviderClient({ region: 'us-west-2' });
      const initiateAuthParams = {
        AuthFlow: 'CUSTOM_AUTH',
        ClientId: '625kot0ri0fqthov5pd26eqbkq',
        AuthParameters: {
          USERNAME: username
        }
      };

      const initiateAuthCommand = new InitiateAuthCommand(initiateAuthParams);
      const initiateAuthResponse = await client.send(initiateAuthCommand);

      var responseSessionId = initiateAuthResponse.Session;
      try {
        console.log("inside try to initiate authentication");
        const sessionId = initiateAuthResponse.Session;
        const respondCommand = new RespondToAuthChallengeCommand({
          ClientId: '625kot0ri0fqthov5pd26eqbkq',
          ChallengeName: 'CUSTOM_CHALLENGE',
          ClientMetadata: { "phase": "PASSWORD" },
          Session: sessionId,
          ChallengeResponses: {
            USERNAME: username,
            ANSWER: password
          }
        });
        const response = await client.send(respondCommand);
        responseSessionId = response.Session;
      } catch (error) {
        if (error.name === "UserLambdaValidationException") {
          setIsSigningIn(false);
          console.error('Error:', error);
          setError("Unrecognized phone!");
          return;
        }
        setIsSigningIn(false);
        console.error('Error:', error);
        setError("Invalid username/password!");
        return;
      }
      var message = "empty";
      const body = {
        username,
        responseSessionId,
        message
      };
      try {
        console.log("inside try to store session id");
        await fetch("https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/storeSessionId", {
          method: "POST",
          body: JSON.stringify(body),
        });

      } catch (error) {
        setIsSigningIn(false);
        setError("Failed to store session id. Please try again later.");
        return;
      }

      var newSessionId = responseSessionId;
      var timeoutCounter = 0;
      var isTimedout = false;
      while (newSessionId === responseSessionId || newSessionId === null) {
        if (timeoutCounter === 30) {
          isTimedout = true;
          break;
        }
        console.log("inside while to get session id");
        const getSessionResponse = await fetch(`https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/userSessionId?username=${username}`, {
          method: "GET",
        });
        const getSessionResponseData = await getSessionResponse.json();
        newSessionId = getSessionResponseData.sessionId;
        message = getSessionResponseData.message;
        console.log("message: ", message);
        if (message === "Location out of range") {
          console.error('Error:', error);
          setError("Location Verification Failed");
          setIsSigningIn(false);
          return;
        } else if (message === "The dongle is not recognized") {
          console.error('Error:', error);
          setError("Unrecognized dongle");
          setIsSigningIn(false);
          return;
        }
        await new Promise(resolve => setTimeout(resolve, 1000));
        timeoutCounter++;

      }
      if (isTimedout) {
        setIsSigningIn(false);
        console.error('Error:', error);
        setError("Location verification timeout");
        deleteSessionId(username)
        return;
      }
      console.log("out of the while loop");
      try {
        console.log('Session Id:', newSessionId);
        const lastRespondCommand = new RespondToAuthChallengeCommand({
          ClientId: '625kot0ri0fqthov5pd26eqbkq',
          ChallengeName: 'CUSTOM_CHALLENGE',
          ClientMetadata: { "phase": "FINAL" },
          Session: newSessionId,
          ChallengeResponses: {
            USERNAME: username,
            ANSWER: "verified"
          }
        });
        await client.send(lastRespondCommand);
      } catch (error) {
        setIsSigningIn(false);
        console.error('Error:', error);
        setError("Location Verification Failed");
        deleteSessionId(username)
        return;
      }
      console.log("authenticated!");
      
      // Store session timestamp
      const sessionData = {
        username: username,
        timestamp: Date.now()
      };
      localStorage.setItem('userSession', JSON.stringify(sessionData));
      
      onSignIn({
        username: username,
        email: "",
        phone: "",
      });

      setError("");
      setIsSigningIn(false);
      navigate('/welcome');
      deleteSessionId(username)
    } catch (error) {
      console.error('Error:', error);
      setIsSigningIn(false);
      deleteSessionId(username)
      setError(error.message || "SignIn failed");
    }
  };

  if (isDeviceRegister) {
    if (showToken) {
      return (
        <div className="header-and-container">
          <div className="header"><span>Bank of Mars</span></div>
          <div className="container">
            <div className="card">
              <h2>Enter this code into your second factor app</h2>
              <h2>{randomToken}</h2>
              <button className="button" onClick={(e) => {
                setDeviceRegister(false);
                setShowToken(false);
                handleSignInCustom(e);
              }
              } disabled={isSigningIn}>{isSigningIn ? (
                <>
                  <Spinner /> <span style={{ marginLeft: '8px' }}>Continuing...</span>
                </>
              ) : (
                'Continue'
              )}</button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="header-and-container">
          <div className="header"><span>Bank of Mars</span></div>
          <div className="container">
            <div className="card">
              <form onSubmit={startDeviceRegisration}>
                <h2>Device Registration</h2>
                <h4>In order to finish signing in, please download the second factor application from <a href="www.google.com" style={{ textDecoration: 'none' }}>App Store</a> and click start device registration below</h4>

                <button type="submit" disabled={isStartingDeviceReg}>
                  {isStartingDeviceReg ? (
                    <>
                      <Spinner /> <span style={{ marginLeft: '8px' }}>Starting...</span>
                    </>
                  ) : (
                    'Start Device Registration'
                  )}
                </button>
                <p className="toggle" onClick={() => {
                  if (isStartingDeviceReg) return;
                  navigate('/signin');
                }}>Go back to Sign In page</p>

              </form>
            </div>
          </div>
        </div>
      );
    }
  }

  return (
    <div className="header-and-container">
      <div className="header"><span>Bank of Mars</span></div>
      <div className="container">
        <div className="card">
          <form onSubmit={handleSignInCustom}>
            <h2>Sign In</h2>

            <label>Username:</label>
            <input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
            {fieldErrors.username && <p className="field-error">{fieldErrors.username}</p>}

            <label>Password:</label>
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            {fieldErrors.password && <p className="field-error">{fieldErrors.password}</p>}

            <button type="submit" disabled={isSigningIn}>
              {isSigningIn ? (
                <>
                  <Spinner /> <span style={{ marginLeft: '8px' }}>Signing In...</span>
                </>
              ) : (
                'Sign In'
              )}
            </button>
            {error && <p className="error">{error}</p>}
            <p className="toggle" onClick={() => navigate('/signup')}>No account? Sign Up</p>
            <p className="toggle" onClick={() => navigate('/update-user')}>Update an existing user</p>
            <p className="toggle" onClick={() => navigate('/reset-password')}>Forgot Password?</p>
          </form>
        </div>
      </div>
    </div>
  );
}

// Sign Up Page Component
function SignUpPage() {
  const navigate = useNavigate();
  //const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dongleSerialNumber, setDongleSerialNumber] = useState("");
  const [maxArea, setMaxArea] = useState("");
  const [minBurstCount, setminBurstCount] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [locations, setLocations] = useState([{ latitude: "", longitude: "", radius: "", comment: "", enabled: true }]);

  const addLocation = () => {
    setLocations([...locations, { latitude: "", longitude: "", radius: "", comment: "", enabled: true }]);
  };

  const removeLocation = (index) => {
    const newLocations = locations.filter((_, i) => i !== index);
    setLocations(newLocations);
  };

  const updateLocation = (index, field, value) => {
    const newLocations = [...locations];
    newLocations[index][field] = value;
    setLocations(newLocations);
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setIsSigningUp(true);

    let errors = {};
    locations.forEach((loc, index) => {
      if (!loc.latitude) errors[`latitude${index}`] = `Latitude ${index + 1} is required`;
      else if (isNaN(parseFloat(loc.latitude))) errors[`latitude${index}`] = `Latitude ${index + 1} must be a number`;

      if (!loc.longitude) errors[`longitude${index}`] = `Longitude ${index + 1} is required`;
      else if (isNaN(parseFloat(loc.longitude))) errors[`longitude${index}`] = `Longitude ${index + 1} must be a number`;

      if (!loc.radius) errors[`radius${index}`] = `Radius ${index + 1} is required`;
      else if (isNaN(parseFloat(loc.radius))) errors[`radius${index}`] = `Radius ${index + 1} must be a number`;
    });
   //  if (!username) errors.username = "Username is required";
    if (!password) errors.password = "Password is required";
    if (!email) errors.email = "Email is required";
    if (!phone) errors.phone = "Phone is required";
    if (!dongleSerialNumber) errors.dongleSerialNumber = "Dongle Serial Number is required";
    if (!maxArea) errors.maxArea = "Maximum Area is required";
    else if (isNaN(parseFloat(maxArea))) errors.maxArea = "Maximum Area must be a number";
    if (!minBurstCount) errors.minBurstCount = "Minimum Burst Count is required";
    else if (isNaN(parseFloat(minBurstCount))) errors.minBurstCount = "Minimum Burst Count must be a number";

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setIsSigningUp(false);
      return;
    }

    try {
      await signUp({
        username: email,
        password,
        options: { userAttributes: { email, phone_number: phone, "custom:dongleserialnumber": dongleSerialNumber, } },
      });

      try {
        const locationArray = locations.map(loc => [
          parseFloat(loc.latitude),
          parseFloat(loc.longitude),
          parseFloat(loc.radius),
          loc.comment || "",
          loc.enabled !== undefined ? loc.enabled : true
        ]);

        const body = {
          email,
          locations: locationArray,
          dongleSerialNumber,
          maxArea,
          minBurstCount
        };

        const response = await fetch("https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/registerUser", {
          method: "POST",
          body: JSON.stringify(body),
        });

        if (response.ok) {
          const conformAcctRes = await fetch(`https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/confirmAccount?username=${email}`, {
            method: "POST",
          });
          if (conformAcctRes.ok) {
            navigate('/success');
          }
          else {
            const errorText = await conformAcctRes.text();
            setError("Account Confirmation failed: " + errorText);
            setIsSigningUp(false);
          }
        } else {
          const errorText = await response.text();
          setError("Registration failed: " + errorText);
          setIsSigningUp(false);
        }
      } catch (err) {
        console.error("Registration error:", err);
        setIsSigningUp(false);
        alert("Registration failed: " + err.message);
      }

      //setUsername("");
      setPassword("");
      setEmail("");
      setPhone("");
      setDongleSerialNumber("");
      setMaxArea("");
      setminBurstCount("");
      setLocations([{ latitude: "", longitude: "", radius: "", comment: "", enabled: true }]);
      setError("");
      setFieldErrors({});
      setIsSigningUp(false);
    } catch (err) {
      console.error("SignUp failed:", err);
      setIsSigningUp(false);
      setError(err.message || "SignUp failed");
    }
  };

  return (
    <div className="header-and-container">
      <div className="header"><span>Bank of Mars</span></div>
      <div className="container">
        <div className="card">
          <form onSubmit={handleSignUp}>
            <h2>Create Account</h2>

            <label>Email:</label>
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            {fieldErrors.email && <p className="field-error">{fieldErrors.email}</p>}

            <label>Username:</label>
            <input type="text" value={email} readOnly />

            <label>Password:</label>
            <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            {fieldErrors.password && <p className="field-error">{fieldErrors.password}</p>}

            <label>Phone:</label>
            <input type="phone" placeholder="Phone (+15555555555)" value={phone} onChange={(e) => setPhone(e.target.value)} />
            {fieldErrors.phone && <p className="field-error">{fieldErrors.phone}</p>}

            <label>Dongle Serial Number:</label>
            <input type="text" placeholder="Dongle Serial Number" value={dongleSerialNumber} onChange={(e) => setDongleSerialNumber(e.target.value)} />
            {fieldErrors.dongleSerialNumber && <p className="field-error">{fieldErrors.dongleSerialNumber}</p>}

            <label>Maximum Area:</label>
            <input type="text" placeholder="Maximum Area" value={maxArea} onChange={(e) => setMaxArea(e.target.value)} />
            {fieldErrors.maxArea && <p className="field-error">{fieldErrors.maxArea}</p>}

            <label>Minimum Burst Count:</label>
            <input type="text" placeholder="Minimum Burst Count" value={minBurstCount} onChange={(e) => setminBurstCount(e.target.value)} />
            {fieldErrors.minBurstCount && <p className="field-error">{fieldErrors.minBurstCount}</p>}

            <h3>Locations</h3>
            {locations.map((loc, index) => (
              <div key={index} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
                <h4>Location {index + 1}</h4>

                <label>Comment:</label>
                <input
                  type="text"
                  placeholder="Comment (optional)"
                  value={loc.comment}
                  onChange={(e) => updateLocation(index, 'comment', e.target.value)}
                  style={{ marginBottom: '10px' }}
                />

                <label>Latitude:</label>
                <input
                  type="text"
                  placeholder="Latitude"
                  value={loc.latitude}
                  onChange={(e) => updateLocation(index, 'latitude', e.target.value)}
                />
                {fieldErrors[`latitude${index}`] && <p className="field-error">{fieldErrors[`latitude${index}`]}</p>}

                <label>Longitude:</label>
                <input
                  type="text"
                  placeholder="Longitude"
                  value={loc.longitude}
                  onChange={(e) => updateLocation(index, 'longitude', e.target.value)}
                />
                {fieldErrors[`longitude${index}`] && <p className="field-error">{fieldErrors[`longitude${index}`]}</p>}

                <label>Radius (meters):</label>
                <input
                  type="text"
                  placeholder="Radius"
                  value={loc.radius}
                  onChange={(e) => updateLocation(index, 'radius', e.target.value)}
                />
                {fieldErrors[`radius${index}`] && <p className="field-error">{fieldErrors[`radius${index}`]}</p>}

                {locations.length > 1 && (
                  <button type="button" onClick={() => removeLocation(index)}>
                    Remove Location
                  </button>
                )}
              </div>
            ))}

            <button type="button" onClick={addLocation}>
              Add Another Location
            </button>

            <button type="submit" disabled={isSigningUp}>
              {isSigningUp ? (
                <>
                  <Spinner /> <span style={{ marginLeft: '8px' }}>Signing Up...</span>
                </>
              ) : (
                'Sign Up'
              )}
            </button>
            {error && <p className="error">{error}</p>}
            <p className="toggle" onClick={() => navigate('/signin')}>Already have an account? Sign In</p>
            <p className="toggle" onClick={() => navigate('/update-user')}>Update an existing user</p>
          </form>
        </div>
      </div>
    </div>
  );
}

// Update User Page Component
function UpdateUserPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [dongleSerialNumber, setDongleSerialNumber] = useState("");
  const [maxArea, setMaxArea] = useState("");
  const [minBurstCount, setminBurstCount] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isLookingUpUser, setIsLookingUpUser] = useState(false);
  const [isUpdatingUser, setIsUpdatingUser] = useState(false);
  const [isEditingUser, setIsEditingUser] = useState(false);
  const [locations, setLocations] = useState([{ latitude: "", longitude: "", radius: "", comment: "", enabled: true }]);

  const addLocation = () => {
    setLocations([...locations, { latitude: "", longitude: "", radius: "", comment: "", enabled: true }]);
  };

  const removeLocation = (index) => {
    const newLocations = locations.filter((_, i) => i !== index);
    setLocations(newLocations);
  };

  const updateLocation = (index, field, value) => {
    const newLocations = [...locations];
    newLocations[index][field] = value;
    setLocations(newLocations);
  };

  const toggleLocationEnabled = (index) => {
    const newLocations = [...locations];
    newLocations[index].enabled = !newLocations[index].enabled;
    setLocations(newLocations);
  };

  const handleLookupUser = async (e) => {
    e.preventDefault();
    setIsLookingUpUser(true);
    setError('');
    setFieldErrors({});

    if (!username.trim()) {
      setFieldErrors({ username: 'Username is required' });
      setIsLookingUpUser(false);
      return;
    }

    try {
      const response = await fetch(`https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/getUser?username=${username}`, {
        method: "GET",
      });

      if (!response.ok) {
        setError("User not found");
        setIsLookingUpUser(false);
        return;
      }

      const data = await response.json();

      setDongleSerialNumber(data.dongleSerialNumber || "");
      setMaxArea(data.maxArea || "");
      setminBurstCount(data.minBurstCount || "");

      if (data.locations && Array.isArray(data.locations)) {
        const formattedLocations = data.locations.map(loc => ({
          latitude: loc[0].toString(),
          longitude: loc[1].toString(),
          radius: loc[2].toString(),
          comment: loc[3] || "",
          enabled: loc[4] && String(loc[4]).toLowerCase() === 'true'
        }));
        setLocations(formattedLocations);
      }

      setIsEditingUser(true);
      setIsLookingUpUser(false);
    } catch (error) {
      console.error('Error:', error);
      setError("User not found");
      setIsLookingUpUser(false);
    }
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    setIsUpdatingUser(true);

    let errors = {};
    locations.forEach((loc, index) => {
      if (!loc.latitude) errors[`latitude${index}`] = `Latitude ${index + 1} is required`;
      else if (isNaN(parseFloat(loc.latitude))) errors[`latitude${index}`] = `Latitude ${index + 1} must be a number`;

      if (!loc.longitude) errors[`longitude${index}`] = `Longitude ${index + 1} is required`;
      else if (isNaN(parseFloat(loc.longitude))) errors[`longitude${index}`] = `Longitude ${index + 1} must be a number`;

      if (!loc.radius) errors[`radius${index}`] = `Radius ${index + 1} is required`;
      else if (isNaN(parseFloat(loc.radius))) errors[`radius${index}`] = `Radius ${index + 1} must be a number`;
    });

    if (!dongleSerialNumber) errors.dongleSerialNumber = "Dongle Serial Number is required";
    if (!maxArea) errors.maxArea = "Maximum Area is required";
    else if (isNaN(parseFloat(maxArea))) errors.maxArea = "Maximum Area must be a number";
    if (!minBurstCount) errors.minBurstCount = "Minimum Burst Count is required";
    else if (isNaN(parseFloat(minBurstCount))) errors.Count = "Minimum Burst Count must be a number";

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setIsUpdatingUser(false);
      return;
    }

    try {
      const locationArray = locations.map(loc => [
        parseFloat(loc.latitude),
        parseFloat(loc.longitude),
        parseFloat(loc.radius),
        loc.comment,
        loc.enabled
      ]);

      const body = {
        username,
        locations: locationArray,
        dongleSerialNumber,
        maxArea,
        minBurstCount
      };

      const response = await fetch("https://t3gbv16eu3.execute-api.us-west-2.amazonaws.com/updateUser", {
        method: "POST",
        body: JSON.stringify(body),
      });

      if (response.ok) {
        alert("User updated successfully!");
        navigate('/signin');
      } else {
        const errorText = await response.text();
        setError("Update failed: " + errorText);
      }
      setIsUpdatingUser(false);
    } catch (err) {
      console.error("Update error:", err);
      setError("Update failed: " + err.message);
      setIsUpdatingUser(false);
    }
  };

  if (!isEditingUser) {
    return (
      <div className="header-and-container">
        <div className="header"><span>Bank of Mars</span></div>
        <div className="container">
          <div className="card">
            <form onSubmit={handleLookupUser}>
              <h2>Update Existing User</h2>

              <label>Username:</label>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              {fieldErrors.username && <p className="field-error">{fieldErrors.username}</p>}

              <button
                type="submit"
                disabled={!username.trim() || isLookingUpUser}
              >
                {isLookingUpUser ? (
                  <>
                    <Spinner /> <span style={{ marginLeft: '8px' }}>Looking up...</span>
                  </>
                ) : (
                  'Look for Username'
                )}
              </button>

              {error && <p className="error">{error}</p>}

              <p className="toggle" onClick={() => navigate('/signin')}>Back to Sign In</p>
              <p className="toggle" onClick={() => navigate('/signup')}>Go to Sign Up</p>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="header-and-container">
      <div className="header"><span>Bank of Mars</span></div>
      <div className="container">
        <div className="card">
          <form onSubmit={handleUpdateUser}>
            <h2>Update User: {username}</h2>

            <label>Dongle Serial Number:</label>
            <input
              type="text"
              placeholder="Dongle Serial Number"
              value={dongleSerialNumber}
              onChange={(e) => setDongleSerialNumber(e.target.value)}
            />
            {fieldErrors.dongleSerialNumber && <p className="field-error">{fieldErrors.dongleSerialNumber}</p>}

            <label>Maximum Area:</label>
            <input
              type="text"
              placeholder="Maximum Area"
              value={maxArea}
              onChange={(e) => setMaxArea(e.target.value)}
            />
            {fieldErrors.maxArea && <p className="field-error">{fieldErrors.maxArea}</p>}

            <label>Minimum Burst Count:</label>
            <input
              type="text"
              placeholder="Minimum Burst Count"
              value={minBurstCount}
              onChange={(e) => setminBurstCount(e.target.value)}
            />
            {fieldErrors.minBurstCount && <p className="field-error">{fieldErrors.minBurstCount}</p>}

            <h3>Locations</h3>
            {locations.map((loc, index) => (
              <div key={index} style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '10px' }}>
                <h4 style={{ margin: 0 }}>Location {index + 1}</h4>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <span style={{ fontSize: '12px', color: loc.enabled ? 'green' : 'red' }}>
                    {loc.enabled ? 'Enabled' : 'Disabled'}
                  </span>
                  <button
                    type="button"
                    onClick={() => toggleLocationEnabled(index)}
                    style={{ padding: '5px 10px', transform: 'scale(0.9)', display: 'inline-block' }}
                  >
                    {loc.enabled ? 'Disable' : 'Enable'}
                  </button>

                </div>

                <label>Comment:</label>
                <input
                  type="text"
                  placeholder="Comment (optional)"
                  value={loc.comment}
                  onChange={(e) => updateLocation(index, 'comment', e.target.value)}
                  style={{ marginBottom: '10px' }}
                />

                <label>Latitude:</label>
                <input
                  type="text"
                  placeholder="Latitude"
                  value={loc.latitude}
                  onChange={(e) => updateLocation(index, 'latitude', e.target.value)}
                />
                {fieldErrors[`latitude${index}`] && <p className="field-error">{fieldErrors[`latitude${index}`]}</p>}

                <label>Longitude:</label>
                <input
                  type="text"
                  placeholder="Longitude"
                  value={loc.longitude}
                  onChange={(e) => updateLocation(index, 'longitude', e.target.value)}
                />
                {fieldErrors[`longitude${index}`] && <p className="field-error">{fieldErrors[`longitude${index}`]}</p>}

                <label>Radius (meters):</label>
                <input
                  type="text"
                  placeholder="Radius"
                  value={loc.radius}
                  onChange={(e) => updateLocation(index, 'radius', e.target.value)}
                />
                {fieldErrors[`radius${index}`] && <p className="field-error">{fieldErrors[`radius${index}`]}</p>}

                {locations.length > 1 && (
                  <button type="button" onClick={() => removeLocation(index)}>
                    Remove Location
                  </button>
                )}
              </div>
            ))}

            <button type="button" onClick={addLocation}>
              Add Another Location
            </button>

            <button type="submit" disabled={isUpdatingUser}>
              {isUpdatingUser ? (
                <>
                  <Spinner /> <span style={{ marginLeft: '8px' }}>Updating...</span>
                </>
              ) : (
                'Update User'
              )}
            </button>

            {error && <p className="error">{error}</p>}

            <p className="toggle" onClick={() => navigate('/signin')}>Back to Sign In</p>
            <p className="toggle" onClick={() => navigate('/signup')}>Go to Sign Up</p>
          </form>
        </div>
      </div>
    </div>
  );
}

// Reset Password Page Component
function ResetPasswordPage() {
  const navigate = useNavigate();
  const [resetEmail, setResetEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [isResettingPassword, setIsResettingPassword] = useState(false);
  const [isVerifyingCode, setIsVerifyingCode] = useState(false);

  const handleSendResetCode = async (e) => {
    e.preventDefault();
    setIsSendingCode(true);
    setError('');
    setFieldErrors({});

    if (!resetEmail.trim()) {
      setFieldErrors({ resetEmail: 'Email is required' });
      setIsSendingCode(false);
      return;
    }

    try {
      await resetPassword({
        username: resetEmail
      });

      alert("Verification code sent to your email!");
      setIsVerifyingCode(true);
      setIsSendingCode(false);

    } catch (error) {
      console.error('Send reset code error:', error);

      if (error.name === 'UserNotFoundException') {
        setError("No account found with this email");
      } else if (error.name === 'LimitExceededException') {
        setError("Too many attempts. Please try again later.");
      } else {
        setError(error.message || "Failed to send verification code");
      }

      setIsSendingCode(false);
    }
  };

  const handleConfirmPasswordReset = async (e) => {
    e.preventDefault();
    setIsResettingPassword(true);
    setError('');
    setFieldErrors({});

    let errors = {};
    if (!verificationCode) errors.verificationCode = "Verification code is required";
    if (!newPassword) errors.newPassword = "New password is required";
    if (!confirmNewPassword) errors.confirmNewPassword = "Confirm new password is required";
    if (newPassword && confirmNewPassword && newPassword !== confirmNewPassword) {
      errors.confirmNewPassword = "Passwords do not match";
    }
    if (newPassword && newPassword.length < 8) {
      errors.newPassword = "Password must be at least 8 characters";
    }

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      setIsResettingPassword(false);
      return;
    }

    try {
      await confirmResetPassword({
        username: resetEmail,
        confirmationCode: verificationCode,
        newPassword: newPassword
      });

      alert("Password reset successfully! Please sign in with your new password.");
      navigate('/signin');

    } catch (error) {
      console.error('Confirm reset error:', error);

      if (error.name === 'CodeMismatchException') {
        setError("Invalid verification code");
      } else if (error.name === 'ExpiredCodeException') {
        setError("Verification code has expired");
      } else if (error.name === 'InvalidPasswordException') {
        setError("Password does not meet requirements");
      } else if (error.name === 'LimitExceededException') {
        setError("Too many attempts. Please try again later.");
      } else {
        setError(error.message || "Password reset failed");
      }

      setIsResettingPassword(false);
    }
  };

  if (!isVerifyingCode) {
    return (
      <div className="header-and-container">
        <div className="header"><span>Bank of Mars</span></div>
        <div className="container">
          <div className="card">
            <form onSubmit={handleSendResetCode}>
              <h2>Reset Password</h2>
              <p style={{ fontSize: '14px', color: '#666' }}>
                Enter your email address and we'll send you a verification code.
              </p>

              <label>Email:</label>
              <input
                type="email"
                placeholder="Email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
              {fieldErrors.resetEmail && <p className="field-error">{fieldErrors.resetEmail}</p>}

              <button type="submit" disabled={isSendingCode}>
                {isSendingCode ? (
                  <>
                    <Spinner /> <span style={{ marginLeft: '8px' }}>Sending Code...</span>
                  </>
                ) : (
                  'Send Verification Code'
                )}
              </button>

              {error && <p className="error">{error}</p>}

              <p className="toggle" onClick={() => navigate('/signin')}>Back to Sign In</p>
              <p className="toggle" onClick={() => navigate('/signup')}>Go to Sign Up</p>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="header-and-container">
      <div className="header"><span>Bank of Mars</span></div>
      <div className="container">
        <div className="card">
          <form onSubmit={handleConfirmPasswordReset}>
            <h2>Reset Password</h2>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Enter the verification code sent to {resetEmail}
            </p>

            <label>Verification Code:</label>
            <input
              type="text"
              placeholder="Verification Code"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
            />
            {fieldErrors.verificationCode && <p className="field-error">{fieldErrors.verificationCode}</p>}

            <label>New Password:</label>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            {fieldErrors.newPassword && <p className="field-error">{fieldErrors.newPassword}</p>}

            <label>Confirm New Password:</label>
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
            />
            {fieldErrors.confirmNewPassword && <p className="field-error">{fieldErrors.confirmNewPassword}</p>}

            <button type="submit" disabled={isResettingPassword}>
              {isResettingPassword ? (
                <>
                  <Spinner /> <span style={{ marginLeft: '8px' }}>Resetting Password...</span>
                </>
              ) : (
                'Reset Password'
              )}
            </button>

            {error && <p className="error">{error}</p>}

            <p className="toggle" onClick={() => setIsVerifyingCode(false)}>Resend Code</p>
            <p className="toggle" onClick={() => navigate('/signin')}>Back to Sign In</p>
          </form>
        </div>
      </div>
    </div>
  );
}

// Main App Component
export default function App() {
  const [user, setUser] = useState(null);
  const [isCheckingSession, setIsCheckingSession] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check localStorage for session
        const sessionData = localStorage.getItem('userSession');
        if (sessionData) {
          const { username, timestamp } = JSON.parse(sessionData);
          const currentTime = Date.now();
          
          // Check if session is still valid (within 60 minutes)
          if (currentTime - timestamp < SESSION_DURATION) {
            // Session is still valid
            try {
              const currentUser = await getCurrentUser();
              if (currentUser) {
                const userAttributes = await fetchUserAttributes();
                setUser({
                  username: userAttributes.username || username,
                  email: userAttributes.email || "",
                  phone: userAttributes.phone_number || "",
                });
              } else {
                setUser({ username, email: "", phone: "" });
              }
            } catch {
              // If Cognito session check fails, still use localStorage session
              setUser({ username, email: "", phone: "" });
            }
          } else {
            // Session expired, clear it
            localStorage.removeItem('userSession');
          }
        }
      } catch (error) {
        console.error('Session check error:', error);
      } finally {
        setIsCheckingSession(false);
      }
    };

    checkSession();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
    localStorage.removeItem('userSession');
    setUser(null);
  };

  if (isCheckingSession) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<SignInPage onSignIn={setUser} />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/update-user" element={<UpdateUserPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/success" element={<SuccessPage onBackToLogin={() => { }} />} />
        <Route
          path="/welcome"
          element={
            <ProtectedRoute user={user}>
              <WelcomePage user={user} onSignOut={handleSignOut} />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to={user ? "/welcome" : "/signin"} replace />} />
      </Routes>
    </Router>
  );
}